import { Component } from "react";

import './rangeSupervision.css';
import LoadingSymbol from '../../LoadingSymbol.js';

export default class RangeSupervision extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loadingData: true,
            entries: []
        }
    }


    async componentDidMount() {
        this.loadData();
    }

    async loadData() {
        this.setState({loadingData: true});

        await this.initData();

        this.setState({loadingData: false});
    }

    async initData() {
        //this.addDividerBig("2025");
        // Oktober
        this.addMonthDivider(10, 2025);
        this.addData(new Date(2025,  9, 29), "Gindele, Daniel",    "Deifel, Erwin");
        // November
        this.addMonthDivider(11, 2025);
        this.addData(new Date(2025, 10,  5), "Herrmann, Daniel",   "Habbes, Carsten");
        this.addData(new Date(2025, 10, 12), "Finsterle, Sabrina", "Schnetz, Roman");
        this.addData(new Date(2025, 10, 19), "Diehl, Waltraud",    "Hinderhofer, Helmut");
        this.addData(new Date(2025, 10, 26), "Deiß, Michaela",     "Schnetz, Thomas");
        // Dezember
        this.addMonthDivider(12, 2025);
        this.addData(new Date(2025, 11,  3), "Wiggenhauser, Rolf", "Schultheiß, Alfred");
        this.addData(new Date(2025, 11, 10), "Tran, Patrick",      "Schönebeck, Rolf");
        this.addData(new Date(2025, 11, 17), "Seiler, Oliver",     "Huber, Berthold");
        //this.addData(new Date(2025, 11, 24), "Heilig Abend",       "Heilig Abend");
        //this.addData(new Date(2025, 11, 31), "Silvester",          "Silvester");
        //this.addDividerBig("2026");
        // Januar
        this.addMonthDivider(1, 2026);
        this.addData(new Date(2026,  0,  7), "Wölfle, Pius",       "Graeff, Florian");
        this.addData(new Date(2026,  0, 14), "Bitterer, Tobias",   "Böhm, Marko");
        this.addData(new Date(2026,  0, 21), "Gindele, Daniel",    "Deifel, Erwin");
        this.addData(new Date(2026,  0, 28), "Herrmann, Daniel",   "Habbes, Carsten");
        // Februar
        this.addMonthDivider(2, 2026);
        this.addData(new Date(2026,  1,  4), "Finsterle, Sabrina", "Schnetz, Roman");
        this.addData(new Date(2026,  1, 11), "Diehl, Waltraud",    "Hinderhofer, Helmut");
        this.addData(new Date(2026,  1, 18), "Deiß, Michaela",     "Schnetz, Thomas");
        this.addData(new Date(2026,  1, 25), "Wiggenhauser, Rolf", "Schultheiß, Alfred");
        // März
        this.addMonthDivider(3, 2026);
        this.addData(new Date(2026,  2,  4), "Tran, Patrick",      "Schönebeck, Rolf");
        this.addData(new Date(2026,  2, 11), "Seiler, Oliver",     "Huber, Berthold");
        this.addData(new Date(2026,  2, 18), "Wölfle, Pius",       "Graeff, Florian");
        this.addData(new Date(2026,  2, 25), "Bitterer, Tobias",   "Böhm, Marko");
        // April
        this.addMonthDivider(4, 2026);
        this.addData(new Date(2026,  3,  1), "Gindele, Daniel",    "Deifel, Erwin");
        this.addData(new Date(2026,  3,  8), "Herrmann, Daniel",   "Habbes, Carsten");
        this.addData(new Date(2026,  3, 15), "Finsterle, Sabrina", "Schnetz, Roman");
        this.addData(new Date(2026,  3, 22), "Diehl, Waltraud",    "Hinderhofer, Helmut");
        this.addData(new Date(2026,  3, 29), "Deiß, Michaela",     "Schnetz, Thomas");
        // Mai
        this.addMonthDivider(5, 2026);
        this.addData(new Date(2026,  4,  6), "Wiggenhauser, Rolf", "Schultheiß, Alfred");
        this.addData(new Date(2026,  4, 13), "Tran, Patrick",      "Schönebeck, Rolf");
        this.addData(new Date(2026,  4, 20), "Seiler, Oliver",     "Huber, Berthold");
        this.addData(new Date(2026,  4, 27), "Wölfle, Pius",       "Graeff, Florian");        
        // Juni
        this.addMonthDivider(6, 2026);
        this.addData(new Date(2026,  5,  3), "Graeff, Florian",		"Habbes, Carsten");
        this.addData(new Date(2026,  5, 10), "Sonntag, Michael",	"Schnetz, Roman");
        this.addData(new Date(2026,  5, 17), "Gindele, Daniel",		"Hinderhofer, Helmut");
        this.addData(new Date(2026,  5, 24), "Herrmann, Daniel",	"Schnetz, Thomas");
        // Juli
        this.addMonthDivider(7, 2026);
        this.addData(new Date(2026,  6,  7), "Diehl, Waltraud",		"Schultheiß, Alfred");
        this.addData(new Date(2026,  6,  8), "Deiß, Michaela",		"Schönebeck, Rolf");
        this.addData(new Date(2026,  6, 15), "Wiggenhauser, Rolf",	"Böhm, Marco");
        this.addData(new Date(2026,  6, 22), "Tran, Patrick",		"Bitterer, Tobias");
        this.addData(new Date(2026,  6, 29), "Seiler, Oliver",		"Deifel, Erwin");
        // August
        this.addMonthDivider(8, 2026);
        this.addData(new Date(2026,  7,  5), "Wöfle, Pius",			"Habbes, Carsten");
        this.addData(new Date(2026,  7, 12), "Graeff, Florian",		"Schnetz, Roman");
        this.addData(new Date(2026,  7, 19), "Sonntag, Michael",	"Hinderhofer, Helmut");
        this.addData(new Date(2026,  7, 26), "Gindele, Daniel",		"Schnetz, Thomas");
        // September
        this.addMonthDivider(9, 2026);
        this.addData(new Date(2026,  8,  2), "Herrmann, Daniel",	"Schultheiß, Alfred");
        this.addData(new Date(2026,  8,  9), "Diehl, Waltraud",		"Schönebeck, Rolf");
        this.addData(new Date(2026,  8, 16), "Deiß, Michaela",		"Böhm, Marco");
        this.addData(new Date(2026,  8, 23), "Wiggenhauser, Rolf",	"Bitterer, Tobias");
        this.addData(new Date(2026,  8, 30), "Tran, Patrick",		"Deifel, Erwin");
        // Oktober
        this.addMonthDivider(10, 2026);
        this.addData(new Date(2026,  9,  7), "Seiler, Oliver",		"Habbes, Carsten");
        //this.addData(new Date(2026,  9, 14), "Königsschießen",		"Königsschießen");
        this.addData(new Date(2026,  9, 21), "Wöfle, Pius",			"Schnetz, Roman");
        this.addData(new Date(2026,  9, 28), "Graeff, Florian",		"Hinderhofer, Helmut");
        // November
        this.addMonthDivider(11, 2026);
        this.addData(new Date(2026, 10,  4), "Sonntag, Michael",	"Schnetz, Thomas");
        this.addData(new Date(2026, 10, 11), "Gindele, Daniel",		"Schultheiß, Alfred");
        this.addData(new Date(2026, 10, 18), "Herrmann, Daniel",	"Schönebeck, Rolf");
        this.addData(new Date(2026, 10, 25), "Diehl, Waltraud",		"Böhm, Marco");
        // Dezember
        this.addMonthDivider(12, 2026);
        this.addData(new Date(2026, 11,  2), "Deiß, Michaela",		"Bitterer, Tobias");
        this.addData(new Date(2026, 11,  9), "Wiggenhauser, Rolf",	"Deifel, Erwin");
        this.addData(new Date(2026, 11, 16), "Tran, Patrick",		"Habbes, Carsten");
        this.addData(new Date(2026, 11, 23), "Seiler, Oliver",		"Schnetz, Roman");
        //this.addData(new Date(2026, 11, 30), "Winterpause",			"Winterpause");
    }

    async addDivider(dividerText) {
        var line = <tr>
            <span className="text-color-blue bold-text">{dividerText}</span>
        </tr>;

        this.state.entries.push(line);
    }

    async addMonthDivider(monthNumber, year) {
        var dateObj = new Date(year, monthNumber - 1, 1);
        var string = dateObj.toLocaleString('default', {month: 'long'});
        this.addDivider(string);        
    }

    async addDividerBig(dividerText) {
        var line = <tr>
            <span className="text-color-green bold-text">{dividerText}</span>
        </tr>;

        this.state.entries.push(line);
    }

    async addData(date, rangeA, rangeB) {
        var line = <tr>
            <td className="column0">
                {new Date(date).toLocaleDateString()}
            </td>
            <td className="column2">
                <span>{rangeA}</span>
            </td>
            <td className="column3">
            <span>{rangeB}</span>
            </td>
        </tr>;

        this.state.entries.push(line);
    }

    render() {
        return (
            <div className="range-supervision">
                <div className="page-content">
                    <header>
                        <h1 className="text-color-green">Schießdienste</h1>
                    </header>
                    <article>
                        <table>
                            <tr>
                                <th className="column0">
                                    <h3 className="text-color-blue">
                                        Datum
                                    </h3>
                                </th>
                                <th className="column1">
                                    <h3 className="text-color-blue">
                                        Luftdruckstand
                                    </h3>
                                </th>
                                <th className="column2">
                                    <h3 className="text-color-blue">
                                        Pistolenstand
                                    </h3>
                                </th>
                            </tr>
                            {
                                Object.keys(this.state.entries).map((key) => {
                                    return (                                        
                                        this.state.entries[key]
                                    );
                                })
                            }
                            {
                                this.state.loadingData ? 
                                    <tr>
                                        <td className="column0"><LoadingSymbol/></td>
                                        <td className="column1"><LoadingSymbol/></td>
                                        <td className="column2"><LoadingSymbol/></td>
                                    </tr> 
                                : 
                                    null
                            }
                        </table>
                    </article>
                </div>
            </div>
        );
    }
}